<template>
  <div>
    <v-dialog
      :model-value="shouldShowModal"
      @update:model-value="handleDialogUpdate"
      aria-describedby="add-to-homescreen-description"
      aria-labelledby="add-to-homescreen-title"
      aria-modal="true"
      content-class="show-modal-popup"
      :scrim="'#212121'"
      :opacity="0.65"
      persistent
      role="dialog"
      scrollable
    >
      <v-card class="items-modal show-modal-popup show-modal-popup__card">
        <v-card-title class="pt-5 pl-5 pr-5 pb-0 flex-column v-header--fixed">
          <div class="d-flex justify-end" style="width: 100%">
            <v-btn
              aria-label="Close dialog"
              icon
              variant="text"
              @click="hideModal"
              width="32"
              height="32"
            >
              <icon aria-hidden="true" height="14" width="14">close-x</icon>
            </v-btn>
          </div>
          <template v-if="isIos">
            <div class="icon-preview-row mt-0">
              <v-avatar
                aria-label="Phone app icon"
                class="icon-ios faded d-block mt-4 mb-5"
                color="grey-darken-3"
                role="img"
                size="57"
              >
                <v-img
                  alt="Phone app icon"
                  src="/mobile-pass-v3/images/addtohomescreen/phone_app_icon.png"
                ></v-img>
              </v-avatar>
              <v-avatar
                :aria-label="`${offer?.name || 'App'} icon`"
                class="icon-ios d-block mt-4 mb-5"
                color="grey-darken-3"
                role="img"
                size="63"
              >
                <v-img
                  v-if="icon"
                  :alt="`${offer?.name || 'App'} icon`"
                  :src="icon.url"
                ></v-img>
              </v-avatar>
              <v-avatar
                aria-label="Camera app icon"
                class="icon-ios faded d-block mt-4 mb-5"
                color="grey-darken-3"
                role="img"
                size="57"
              >
                <v-img
                  alt="Camera app icon"
                  src="/mobile-pass-v3/images/addtohomescreen/camera_app_icon.png"
                ></v-img>
              </v-avatar>
            </div>
            <h4 id="add-to-homescreen-title" class="text-center my-2">
              Add to Home Screen?
            </h4>
          </template>
          <template v-if="isAndroid">
            <div class="icon-preview-row mt-12">
              <v-avatar
                aria-label="Phone app icon"
                class="icon-android faded d-block mt-4 mb-5"
                color="grey-darken-3"
                role="img"
                size="57"
              >
                <v-img
                  alt="Phone app icon"
                  src="/mobile-pass-v3/images/addtohomescreen/phone_app_icon-android.png"
                ></v-img>
              </v-avatar>
              <v-avatar
                :aria-label="`${offer?.name || 'App'} icon`"
                class="icon-android d-block mt-4 mb-5"
                color="grey-darken-3"
                role="img"
                size="63"
              >
                <v-img
                  v-if="icon"
                  :alt="`${offer?.name || 'App'} icon`"
                  :src="icon.url"
                ></v-img>
              </v-avatar>
              <v-avatar
                aria-label="Camera app icon"
                class="icon-android faded d-block mt-4 mb-5"
                color="grey-darken-3"
                role="img"
                size="57"
              >
                <v-img
                  alt="Camera app icon"
                  src="/mobile-pass-v3/images/addtohomescreen/camera_app_icon-android.png"
                ></v-img>
              </v-avatar>
            </div>
            <h4 id="add-to-homescreen-title" class="text-center my-2">
              Install App?
            </h4>
          </template>
          <template v-if="!isAndroid && !isIos && !isStandAlone">
            THIS IS PROBABLY DESKTOP
          </template>
        </v-card-title>
        <v-card-subtitle
          id="add-to-homescreen-description"
          class="text-center add-to-homescreen__subtitle"
        >
          Make it easy to access your {{ offer.name }} {{ passOrCardWord }} from your home
          screen.
        </v-card-subtitle>
        <v-card-text>
          <v-divider class="mt-1 mb-7"></v-divider>
          <div aria-labelledby="ios-instructions" role="group">
            <p
              v-if="isIos"
              id="ios-instructions"
              class="text-center text-body-2"
            >
              Just tap the
              <icon
                aria-label="share button"
                fill="rgb(var(--v-theme-primary))"
                height="18"
                role="img"
                style="position: relative; top: 4px"
                width="18"
              >
                share
              </icon>
              icon below and then scroll down to 'Add to Home.'
            </p>
          </div>
          <div aria-labelledby="ios-instructions" role="group">
            <p v-if="isAndroid" class="text-center text-body-2">
              Just tap the
              <icon
                aria-label="menu button"
                fill="rgb(var(--v-theme-primary))"
                height="18"
                role="img"
                style="position: relative; top: 4px"
                width="18"
              >
                ellipsis-vertical
              </icon>
              icon above and then look for 'Install App.'
            </p>
            <p class="text-center text-body-2">
              Once you install the app, you may close this tab.
            </p>
          </div>
        </v-card-text>
        <v-card-actions v-if="!isIos && !isAndroid" class="pa-5 flex-column">
          <small class="text-center mb-3">
            <v-btn
              v-if="false"
              color="primary"
              height="25"
              icon
              variant="outlined"
              width="25"
            >
              <v-icon size="15">mdi-help</v-icon>
            </v-btn>
          </small>
          <v-btn
            aria-label="Add app to home screen"
            color="primary"
            rounded
            size="large"
            variant="flat"
            width="100%"
            @click="$emit('redeem')"
          >
            Yes, Please!
          </v-btn>

          <v-btn
            aria-label="Install app"
            class="ms-2"
            color="primary"
            rounded
            variant="flat"
            @click="showPrompt"
          >
            Yes, Please!
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
import MD from 'mobile-detect';
import { mapState, mapGetters } from 'vuex';

/** Set to true to show the modal by default (for testing), regardless of device or dismiss state. */
const SHOW_A2HS_FOR_TESTING = false;

export default {
  name: 'AddToHomeScreen',
  props: {
    settings: {
      type: Object,
      default: () => ({})
    }
  },
  data: () => ({
    deferredPrompt: null,
    forceHide: false,
    isInstalled: true,
    beforeinstallpromptEvent: null,
    appinstalledEvent: null
  }),
  mounted() {
    this.beforeinstallpromptEvent = e => {
      // ! Prevent Chrome 67 and earlier from automatically showing the prompt
      e.preventDefault();
      // Stash the event so it can be triggered later.
      this.deferredPrompt = e;
      // Since this event fires the app is not previously installed
      this.isInstalled = false;
      this.forceHide = false;
    };

    window.addEventListener(
      'beforeinstallprompt',
      this.beforeinstallpromptEvent
    );

    this.appinstalledEvent = () => {
      this.deferredPrompt = null;
      this.forceHide = true;
      this.isInstalled = true;
      window.location.reload();
    };

    window.addEventListener('appinstalled', this.appinstalledEvent);
  },
  beforeUnmount() {
    window.removeEventListener(
      'beforeinstallprompt',
      this.beforeinstallpromptEvent
    );
    window.removeEventListener('appinstalled', this.appinstalledEvent);
  },
  created() {
    if ('serviceWorker' in navigator) {
      navigator.serviceWorker.register('/sw.js').then(() => {
        console.log('Service worker registered');
      });
    }
    setTimeout(() => {
      this.isInstalled = false;
    }, 10000);
  },
  computed: {
    ...mapState(['offer']),
    ...mapState(['partner']),
    ...mapState('auth', { isLoggedIn: 'validated' }),
    ...mapGetters('deals', { findDeal: 'find' }),
    ...mapGetters('orderDeals', { orderDealsList: 'list' }),
    ...mapGetters('bingo', ['hasBingo']),
    currentDealId() {
      const first = this.orderDealsList?.[0];
      const fromOrder = first?.deal_id ?? first?.deal?.id ?? null;
      if (fromOrder != null) return fromOrder;
      const fromRoute = this.$route?.params?.dealId;
      if (fromRoute != null) return parseInt(fromRoute, 10);
      return this.offer?.id ?? null;
    },
    dealHasBingo() {
      // Offer may have bingo flag (e.g. when offer is the deal from initial data)
      const fromOffer =
        this.offer?.has_bingo ??
        this.offer?.hasBingo ??
        this.offer?.pass_settings?.bingo;
      if (fromOffer) return true;

      // Deal from store (has_bingo is set when assignments are loaded)
      const dealId = this.currentDealId;
      if (dealId != null) {
        const deal = this.findDeal(dealId);
        const fromDeal =
          deal?.has_bingo ??
          deal?.hasBingo ??
          deal?.pass_settings?.bingo;
        if (fromDeal) return true;
      }

      // Fallback: bingo module loaded (grid present) means this deal has bingo
      return !!this.hasBingo;
    },
    passOrCardWord() {
      return this.dealHasBingo ? 'card' : 'pass';
    },
    avatarClass() {
      if (this.isIos) return 'icon-ios';
      if (this.isAndroid) return 'avatar-android';
      return null;
    },
    icon() {
      const offerImg = this.offer?.media?.find(
        m => (m.location === 'Logo' || m.location === 'Icon196') && m.url
      );

      const partnerImg = this.partner?.media?.find(
        m => (m.location === 'Logo' || m.location === 'Icon196') && m.url
      );
      return offerImg || partnerImg;
    },
    mobileDetect() {
      return new MD(navigator.userAgent);
    },
    isMobile() {
      return !!this.mobileDetect.mobile();
    },
    isAndroid() {
      return !!(
        this.mobileDetect.os() &&
        ['androidos'].indexOf(this.mobileDetect.os().toLowerCase()) >= 0
      );
    },
    isSaf() {
      return this.mobileDetect.userAgent() === 'Safari';
    },
    isIos() {
      return ['iOS', 'iPadOS'].indexOf(this.mobileDetect.os()) >= 0;
    },
    isStandAlone() {
      return (
        ('standalone' in window.navigator && window.navigator.standalone) ||
        window.matchMedia('(display-mode: standalone)').matches
      );
    },
    wasDismissed() {
      return !!window.localStorage.bw_a2hs_message;
    },
    forceShow() {
      return this.settings.forceShow || false;
    },
    shouldShowModal() {
      if (SHOW_A2HS_FOR_TESTING) return true;
      return (
        this.isLoggedIn &&
        !this.forceHide &&
        (this.forceShow ||
          // We have mobile iOS or Android here
          (!this.isStandAlone &&
            !this.wasDismissed &&
            (this.isIos || this.isAndroid)))
        /*  ||
            // We have desktop here probably
            (!this.isStandAlone &&
              !this.isIos &&
              !this.isAndroid &&
              !window.localStorage.bw_a2hs_message &&
              !this.isInstalled) */
      );
    }
  },
  watch: {
    shouldShowModal(newValue) {
      if (newValue) {
        this.$nextTick(() => {
          // Focus the close button when dialog opens for better accessibility
          const closeButton = this.$el.querySelector(
            '[aria-label="Close dialog"]'
          );
          if (closeButton) closeButton.focus();
        });
      }
    }
  },
  methods: {
    handleDialogUpdate(isOpen) {
      if (!isOpen) this.hideModal();
    },
    hideModal() {
      window.localStorage.setItem('bw_a2hs_message', 'hide');
      this.forceHide = true;
    },
    showPrompt() {
      // Show the prompt
      this.deferredPrompt.prompt();
      // Wait for the user to respond to the prompt
      this.deferredPrompt.userChoice.then(choiceResult => {
        if (choiceResult.outcome === 'accepted') {
          // Call another function?
        }
        this.deferredPrompt = null;
      });
    }
  }
};
</script>

<style lang="scss" scoped>
.v-avatar {
  &.icon-ios,
  &.icon-android {
    background: none !important;
    margin: 0 0.625rem 1rem !important;
    top: -38px;
    box-shadow:
      0 10px 10px 0 rgba(0, 0, 0, 0.3),
      0 10px 20px 0 rgba(0, 0, 0, 0.1);
    overflow: initial;
    position: relative;
    z-index: 2;

    &:not(.faded)::before {
      align-items: center;
      border: dashed 2px rgba(0, 0, 0, 0.3);
      color: rgba(0, 0, 0, 0.3);
      content: '+';
      display: flex;
      font-size: 30px;
      font-weight: 700;
      height: 57px;
      justify-content: center;
      left: 3px;
      position: absolute;
      top: 38px;
      width: 57px;
      z-index: 0;
    }

    &.faded {
      top: 0;
      opacity: 0.5;
    }
  }

  &.icon-ios {
    border-radius: 14px !important;

    &:not(.faded)::before {
      border-radius: 12px !important;
    }

    &.faded {
      box-shadow: none !important;
    }
  }

  &.icon-android {
    border-radius: 50% !important;

    &:not(.faded)::before {
      border-radius: 50% !important;
    }

    &.faded {
      box-shadow:
        0 2px 2px 1px rgba(0, 0, 0, 0.4),
        0 -1px 0 0 black inset;
    }
  }
}

.add-to-homescreen__subtitle {
  white-space: normal;
  word-wrap: break-word;
  overflow-wrap: break-word;
}

.icon-preview-row {
  display: flex;
  justify-content: center;
  align-items: flex-end;
  width: 100%;
}

.v-avatar.icon-android :deep(.v-img),
.v-avatar.icon-android :deep(.v-img__img) {
  border-radius: 50%;
}

.v-avatar.icon-ios :deep(.v-img),
.v-avatar.icon-ios :deep(.v-img__img) {
  border-radius: 14px;
}

.show-modal-popup {
  &__card {
    max-width: min(100dvw - 2rem, var(--project-max-width) - 2rem);
    max-height: 94%;
    margin: 0;
    border-radius: 2rem !important;
  }
  
  h4 {
      font-size: 1.125rem !important;
      line-height: 1.375rem !important;
      padding-bottom: 4px;
  }
}

:deep(.v-overlay__content) {
  max-height: calc(100% - 48px);
  width: calc(100% - 0px);
  max-width: calc(100% - 0px);
  margin: 24px;
}

.show-modal-popup :deep(.text-body-2) {
    font-size: 0.875rem !important;
    font-weight: 400;
    line-height: 1.25rem !important;
    text-transform: none !important;
    margin-top: 0px;
    color: rgba(0, 0, 0, 0.60) !important;
    margin-bottom: 16px !important;
}

.show-modal-popup :deep(.v-divider) {
  border-color: rgba(0, 0, 0, 1) !important;
}
.show-modal-popup :deep(.v-card-subtitle) {
  padding-bottom: 8px !important;
  letter-spacing: 0.0071428571em !important;
  line-height: 1.375rem !important;
  color: rgba(0, 0, 0, 1) !important;
}
</style>
